// @flow
export type YourOrdersActionType = {|
  type: 'DISMISS_DELIVERY_RESOURCE',
  payload: {
    ouid: string,
  },
|};

export const dismissDeliveryResource = (ouid: string): YourOrdersActionType => ({
  type: 'DISMISS_DELIVERY_RESOURCE',
  payload: {
    ouid,
  },
});
